const useHairPredictionRetry = ({
  hairPredictionRetryCount,
  hairPredictionNeedsRetry,
  dispatch,
  setHairRetryCount,
  setHairNeedsRetry,
  clearPhoto,
  openCamera,
}) => {
  const retryHairPrediction = () => {
    if (hairPredictionRetryCount >= 1) return

    dispatch(
      setHairRetryCount(hairPredictionRetryCount + 1),
    )

    dispatch(setHairNeedsRetry(false))

    clearPhoto()
    openCamera()
  }
const showHairPredictionRetryButton =
  hairPredictionNeedsRetry && hairPredictionRetryCount < 1

return {
  retryHairPrediction,
  showHairPredictionRetryButton,
}
}

export default useHairPredictionRetry